import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AddressClient, AddressView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class AddressService {
    constructor(private readonly client: AddressClient) {}

    async searchPlaces(query: string, limit: number | undefined): Promise<AddressView[]> {
        return await lastValueFrom(this.client.addressSearchPlaces(query, limit));
    }

    async staticImageContentById(
        id: number,
        zoomLevel: number | undefined,
        width: number | undefined,
        height: number | undefined
    ): Promise<string> {
        return await lastValueFrom(this.client.addressStaticImageById(id, zoomLevel, width, height));
    }

    async staticImageContent(
        latitude: number,
        longitude: number,
        zoomLevel: number | undefined,
        width: number | undefined,
        height: number | undefined
    ): Promise<string> {
        return await lastValueFrom(this.client.addressStaticImage(latitude, longitude, zoomLevel, width, height));
    }
}
